import React, { Component } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import apiError from '../../error';
import axios from '../../axios';
import CopyIntegrationApiToken from '../copy-integration-api-token/copy-integration-api-token';
export default class CreateIntegrationApiToken extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenName: '',
            expiryDate: '',
            showCopyModal: false,
            companyIntegrationApiToken: {},
            apiKey: ''
        }
    }
    
    createIntegrationApiToken = async () => {
        try {
            if (!this.state.tokenName) {
                toast.error("Please enter token name");
                return;
            }
            if (!this.state.expiryDate) {
                toast.error("Please select expiry date");
                return;
            }
            const pickedLocal = new Date(this.state.expiryDate);
            if (isNaN(pickedLocal) || pickedLocal.getTime() <= Date.now()) {
                toast.error("Please select a future expiry date");
                return;
            }
            const response = await axios.post('/api/company-integration/generate-api-token', {
                apiKeyName: this.state.tokenName,
                expiryDate: new Date(this.state.expiryDate).toISOString()
            });
            toast.success(response.data.message);
            this.props.hideModal();
            this.setState({ showCopyModal: true, apiKey: response.data.companyIntegration?.apiKey });
        } catch (error) {
            apiError(error);
        }
    }
    handleClose = () => {
        this.setState({ tokenName: '', expiryDate: '' });
        this.props.hideModal();
    }

    render() {
        return (
            <>
                <Modal show={this.props.showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h5>Create API Token</h5>
                            <p>Create a new token for authenticated API requests</p>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form.Label>Token Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name here" value={this.state.tokenName} onChange={(e) => this.setState({ tokenName: e.target.value })} />
                        </div>
                    </Modal.Body>
                    <Modal.Body>
                        <div>
                            <Form.Label>Expires On</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                value={this.state.expiryDate}
                                min={(() => { 
                                    const d=new Date(); 
                                    const p=n=>String(n).padStart(2,'0'); 
                                    const Y=d.getFullYear(); 
                                    const M=p(d.getMonth()+1); 
                                    const D=p(d.getDate()); 
                                    const h=p(d.getHours()); 
                                    const m=p(d.getMinutes()); 
                                    return `${Y}-${M}-${D}T${h}:${m}` })()
                                }
                                onChange={e => this.setState({ expiryDate: e.target.value })}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='btn closeBtn' onClick={this.handleClose}>Close</Button>
                        <Button className='btn btn-success' onClick={this.createIntegrationApiToken}>Create</Button>
                    </Modal.Footer>
                </Modal>
                <CopyIntegrationApiToken
                    apiKey={this.state.apiKey}
                    showModal={this.state.showCopyModal}
                    hideModal={() => this.setState({ showCopyModal: false, tokenName: '', expiryDate: '', apiKey: '' })}
                />
            </>
        );
    }
}